module.exports = __webpack_public_path__ + "img/main_doll@2x.a765a851.jpg";